<template>
  <Box
    v-if="video.altContent?.type === 'box'"
    :box="video.altContent"
    :parentLayout="parentLayout"
    :parentSpacing="parentSpacing"
    :direction="direction"
    :parentPath="parentPath + 'altContent.'"
    :hoverPath="hoverPath"
    :editPath="editPath"
    :isAdmin="isAdmin"
    @onSelectNode="selectNode"
    @initListNode="initListNode"
  />
  <Image
    v-if="video.altContent?.type === 'image'"
    :image="video.altContent"
    :parentLayout="parentLayout"
    :direction="direction"
    :parentPath="parentPath + 'altContent.'"
    :hoverPath="hoverPath"
    :editPath="editPath"
    :isAdmin="isAdmin"
    @onSelectNode="selectNode"
    @initListNode="initListNode"
  />
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IFlexMessageVideo } from '@/utils/types'
import Image from '@/components/common/flex-message/components/Image.vue'

@Options({
  components: { Image },
  directives: { maska },
  emits: ['onSelectNode', 'initListNode'],
})
export default class Video extends Vue {
  @Prop()
  video!: IFlexMessageVideo

  @Prop()
  parentLayout!: string

  @Prop()
  parentSpacing!: string

  @Prop()
  direction!: string

  @Prop()
  parentPath!: string

  @Prop()
  hoverPath!: string

  @Prop()
  editPath!: string

  @Prop()
  isAdmin!: boolean

  selectNode(node, path) {
    this.$emit('onSelectNode', node, path)
  }

  initListNode(path) {
    this.$emit('initListNode', path)
  }

  beforeCreate() {
    this.$options.components!.Box = require('@/components/common/flex-message/components/Box.vue').default
  }
}
</script>

<style scoped lang="scss">

</style>
